import styled from 'styled-components'

import { Button, Typography } from '@material-ui/core'

import colors from '@galo-monitor/styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: ${ props => props.column ? 'column' : 'row' };
  gap: ${ props => props.column ? '5px' : '25px' };
`

export const Flex = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LinkText = styled.span`
  color: ${ colors.link };
  text-decoration: underline;
  cursor: pointer;
`

export const TypeButton = styled(Button)`
  padding: 10px 30px 10px 15px;
  border-radius: unset;
  box-shadow: unset;

  text-transform: capitalize;

  & > span:first-child {
    display: flex;
    gap: 15px;
  }
`

export const SectionTitle = styled(Typography)`
  font-size: 0.875rem;
`
